module.exports = __webpack_public_path__ + "img/originator-sunqianhao.051762bd.png";